import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { memo, useEffect, useState } from 'react';
import { date } from '@crehana/utils';
import { usePlaybackContext } from "../../../context/Playback";
import { useUIContext } from "../../../context/UI";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Timestamp = function Timestamp(_ref) {
  var visible = _ref.visible,
    hoveredTime = _ref.hoveredTime,
    progressWidth = _ref.progressWidth;
  var _usePlaybackContext = usePlaybackContext(),
    videoId = _usePlaybackContext.videoId,
    duration = _usePlaybackContext.duration;
  var _useUIContext = useUIContext(),
    thumbnails = _useUIContext.thumbnails;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    thumbnailList = _useState2[0],
    setThumbnailList = _useState2[1];

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    if (thumbnails !== null && thumbnails !== void 0 && thumbnails.length) {
      setThumbnailList(thumbnails.map(function (thumbnail, index) {
        var nextThumbnail = thumbnails[index + 1];
        return _objectSpread(_objectSpread({}, thumbnail), {}, {
          nextPosition: nextThumbnail ? nextThumbnail.position : duration
        });
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(thumbnails), duration, videoId]);
  var timestampWidth = thumbnailList.length ? 96 * 16 / 9 : 48;
  var hoveredProgress = hoveredTime / duration;
  var left = progressWidth * hoveredProgress - timestampWidth / 2;
  if (left < 0) {
    left = 0;
  } else if (left > progressWidth - timestampWidth) {
    left = progressWidth - timestampWidth;
  }
  var currentThumbnail = thumbnailList.find(function (thumbnail) {
    return hoveredTime >= thumbnail.position && hoveredTime < thumbnail.nextPosition;
  });
  return /*#__PURE__*/_jsx("div", {
    className: "flex absolute z-1 pb-8 ".concat(visible ? 'cui-is-visible' : 'cui-is-hidden'),
    style: {
      width: "".concat(timestampWidth, "px"),
      left: "".concat(left, "px"),
      bottom: '12px'
    },
    children: thumbnailList.length > 0 ? /*#__PURE__*/_jsxs("div", {
      className: "relative h-96 w-full bg-base-main border border-solid border-base-main",
      children: [thumbnailList.map(function (thumbnail) {
        return /*#__PURE__*/_jsx("div", {
          className: "absotule top-0 left-0 w-full h-full ".concat(currentThumbnail && currentThumbnail.originalId === thumbnail.originalId ? 'block' : 'hidden'),
          style: {
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundImage: "url(".concat(thumbnail.url, ")")
          }
        }, "thumbnail-".concat(thumbnail.originalId));
      }), /*#__PURE__*/_jsx("div", {
        className: "absolute z-1 bottom-0 flex items-center justify-center w-48 h-24 bg-base-main text-white font-label",
        style: {
          left: '50%',
          transform: 'translateX(-50%)'
        },
        children: date.toTimestamp(hoveredTime)
      })]
    }) : /*#__PURE__*/_jsx("div", {
      className: "flex items-center justify-center w-full h-24 bg-base-main text-white font-label",
      children: date.toTimestamp(hoveredTime)
    })
  });
};
export default /*#__PURE__*/memo(Timestamp);